// contexts/produtos/NCMContext.js
import { createContext, useContext, useState } from 'react';
import { fetchData } from '../../services/Api';
import { useMessage } from '../geral/MessageContext';
import { NCM } from '../../models/produtos/NCM';

const NCMContext = createContext();

export const useNCM = () => useContext(NCMContext);

export const NCMProvider = ({ children }) => {
    const [NCMs, setNCMs] = useState([]);
    const [ncmSel, setNcmSel] = useState(new NCM());
    const { showMessage } = useMessage();

    // useEffect(() => {
    //     const fetchDataFromAPI = async () => {
    //         try {
    //             const result = await fetchData('/NCM');
    //             setNCMs(result);                
    //         } catch (error) {
    //             console.error("Erro ao buscar NCMs:", error);
    //             showMessage(error);
    //         }
    //     };
    //     fetchDataFromAPI();
    // }, []);

    const fetchNCMs = async () => {
      try {
            if (NCMs.length===0)
            {
              const result = await fetchData('/NCM');
              setNCMs(result); 
            }
                             
          } catch (error) {
              console.error("Erro ao buscar NCMs:", error);
              showMessage('Erro ao buscar NCMs!\n' + error, 'danger');
          }    
      }
    const fetchNcmByCodigo = async (codigo) => {
      try {
            if (NCMs.length===0)
            {
              const result = await fetchData('/NCM/GetByCodigo',{codigo});
              setNcmSel(result); 
            }
                             
          } catch (error) {
              console.error("Erro ao buscar NCMs:", error);
              showMessage('Erro ao buscar NCMs!\n' + error, 'danger');
          }    
      }


    return (
        <NCMContext.Provider value={{ NCMs, ncmSel, fetchNcmByCodigo, fetchNCMs }}>
            {children}
        </NCMContext.Provider>
    );
};